import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/apiClient';
import { PanelMenu } from 'primereact/panelmenu';
import CommonConfig from '../../utils/constant';
import APIConstant from '../../utils/pathConstants';
import logo from '../../assets/images/Logo.svg';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import Header from '../Header/Header';

const Sidebar = (props) => {
  const [sidebarMenus, setSidebarMenus] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const user = CommonConfig.loginData();
    getUserMenu();
  }, [])

  const getUserMenu = async () => {
    try {
      const user = CommonConfig.loginData();
      const data = { UserId: user?._id, RoleId: user?.UserType };
      const res = await api.post(APIConstant.path.getUserMenu, data);
      if (res.success) {
        if (res.data.length) {
          setSidebarMenus(transformMenuData(res.data));
        } else {
          navigate('/edit-profile');
        }
      } else {
        setSidebarMenus([]);
      }
    } catch (err) {
      console.error('Error fetching user menu:', err);
    }
  };

  const transformMenuData = (data) => {
    return data.map((menu) => {
      const transformedMenu = {
        label: menu.Title,
        icon: menu.Icon || 'pi pi-fw pi-info-circle',
        path: menu?.Path,
        isActive: false,
      };

      if (menu.Children && menu.Children.length > 0) {
        transformedMenu.items = menu.Children.map((child) => {
          const transformedChild = {
            label: child.Title,
            icon: child.Icon || 'pi pi-fw pi-folder',
            path: child?.Path,
            isActive: false
          };
          if (child.ChildSubMenus && child.ChildSubMenus.length > 0) {
            transformedChild.items = child.ChildSubMenus.map((subChild) => ({
              label: subChild.Title,
              icon: subChild.Icon || 'pi pi-fw pi-file',
              path: subChild?.Path,
              isActive: false
            }));
          }
          return transformedChild;
        });
      }
      return transformedMenu;
    });
  };

  return (
    <div className={`sidebar ${isExpanded ? '' : 'collapse'}`}>
      <div>
        <div className='sidebar-head'>
          <div className="logo">
            <img src={logo} alt="" width={70} />
          </div>
          <Button icon="pi pi-angle-double-left" onClick={() => setIsExpanded(!isExpanded)} />
        </div>
        {sidebarMenus.length > 0 ? (
          <nav>
            {sidebarMenus.map((x, idx) => {
              return (
                <div className='sidebar-menuitem' key={idx}>
                  <a href={x?.path} className={(window.location.pathname == x.path || (x.items?.map(i => i.path)?.includes(window.location.pathname))) ? "active" : ""} onClick={(e) => {
                    if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
                      e.preventDefault();
                      if (x.items) {
                        let tempSideMenus = [...sidebarMenus];
                        tempSideMenus[idx]['isActive'] = !tempSideMenus[idx]['isActive'];
                        setSidebarMenus(tempSideMenus);
                      }
                      else {
                        navigate(x.path)
                      }
                    }
                  }}>
                    <i className={x.icon} />
                    {isExpanded ? x.label : null}
                    {x.items && isExpanded ? <i className={`t-menu-toggle-icon pi ${x.isActive ? 'pi-angle-up' : 'pi-angle-down'}`} /> : null}
                  </a>
                  {isExpanded && x.isActive ?
                    <div class="header-submenu">
                      {x.items?.map((child, indx) => {
                        return (
                          <a className={window.location.pathname == child.path ? "submenu-item active" : "submenu-item"} href={child?.path} key={indx} onClick={(e) => {
                            if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
                              e.preventDefault();
                              navigate(child.path)
                            }
                          }}>{child.label}</a>
                        )
                      })}</div>
                    : null}
                </div>
              )
            })}
          </nav>
        ) : (
          <p>No menus available</p>
        )}
      </div>
      <div>
        <span style={{ display: 'block', textAlign: 'center', color: '#1c515e' }}>&copy; 2025 All rights reserved by </span><a href='https://www.portlinksindia.com/' target='blank' style={{ textDecoration: 'none', display: 'block', textAlign: 'center', fontWeight: 'bold', color: '#1c515e' }}>PORTLINKS INDIA</a>
        <Header isExpanded={isExpanded} />
      </div>
    </div>
  );
};

export default Sidebar;

